import {btn, comp, Component, Config, p, progress} from "@intermesh/goui";
import {t} from "../util/Translate.js";
import {CurrentUser} from "../services/CurrentUser.js";

export class CountdownPanel extends Component {

	private countdownSeconds!: number;
	public interval: any;
	private countdownLabel: Component;
	private rangeFld: Component
	public inProgress = false;

	constructor(public timeoutSeconds: number = 60) {
		super("section");
		this.cls = "card";

		this.countdownSeconds = timeoutSeconds;

		const cmp = comp({},
			comp({height: 150, cls: "vbox gap"},
				comp({},
					this.countdownLabel = p({
						cls: "ifw-center",
						text: t("The application will exit automatically in {countDown} seconds.",
							"core", "core", {
								countDown: String(timeoutSeconds)
							})
					}),
					comp({
							cls: "ifw-center",
							height: 36
						},

						this.rangeFld = progress({
							id: "ifw-countdown",
							cls: "ifw-range",
							tagName: "progress",
							width: 550,
							attr: {
								min: "0",
								max: "100",
								value: "100"
							}
						})
					),
					comp({
							cls: "ifw-center",
							flex: 1
						},
						btn({
							html: t("Exit"),
							handler: () => {
								this.timeoutHandler();
							}
						})
					)
				),
			));
		this.items.add(cmp);

		this.on("beforeremove",() => {
			this.stopCountdown(false);
		});
	}


	public startCountdown() {
		const timeout = this.countdownSeconds;
		let countDown = timeout, countDownProgress = 100;
		this.inProgress = true;

		this.interval = setInterval(() => {
			countDown -= 0.1;
			this.countdownLabel.text = t("The application will exit automatically in {countDown} seconds.",
				"core", "core", {
					countDown: String(Math.ceil(countDown))
				})
			countDownProgress = Math.round((countDown * 100 / timeout));
			(this.rangeFld.el as HTMLProgressElement).value = countDownProgress;

			if (countDown <= 0) {
				this.stopCountdown(true);
			}
		}, 100);
	}

	public stopCountdown(doLogout: boolean) {
		this.inProgress = false;
		clearInterval(this.interval);
		if (doLogout) {
			this.timeoutHandler();
		}
	}

	public isInProgress(): boolean {
		return this.inProgress;
	}

	public timeoutHandler() {
		CurrentUser.logout();
	}
}

export const countdownpanel = (config?: Config<CountdownPanel>) => Object.assign(new CountdownPanel(config?.timeoutSeconds), config);